import React, { useEffect, useCallback, useRef } from "react";
import useState from "react-usestateref";
import { Button } from "@material-ui/core";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";
import { socket } from "../context/socket";
import "./Trade.css";
import moment from "moment";
import Box from "@mui/material/Box";
import "./OptionalTrade.css";
import { greeksTabs, subHeadCoin } from "./optionaltradedata";
import { Bars } from "react-loader-spinner";
import { postMethod } from "../core/service/common.api";
import BinanceOptionsChart from "./BinanceOptionsChart";
import { toast } from "react-toastify";
import apiService from "../core/service/detail";
import { Dropdown } from "semantic-ui-react";
import { Drawer } from "@material-ui/core";

const getTimeToExpiry = (dateStr) => {
  if (!dateStr) return null;

  const expiryDate = new Date(
    `20${dateStr.slice(0, 2)}-${dateStr.slice(2, 4)}-${dateStr.slice(
      4,
      6
    )}T08:00:00Z`
  );
  const now = new Date();

  const diff = expiryDate - now;
  if (diff <= 0) return "Expired";

  const hours = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(
    2,
    "0"
  );
  const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(
    2,
    "0"
  );
  const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

  return `${hours}:${minutes}:${seconds}`;
};

export const useExpiryCountdown = (dateStr) => {
  const [countdown, setCountdown] = useState(() => getTimeToExpiry(dateStr));

  useEffect(() => {
    if (!dateStr) return;

    const update = () => setCountdown(getTimeToExpiry(dateStr));

    update(); // call immediately
    const interval = setInterval(update, 1000);

    return () => clearInterval(interval);
  }, [dateStr]); // 💥 key: watch for dateStr change

  return countdown;
};

function OptionalTrade() {
  const [Draweropen, setDrawer] = useState(false);

  const toggleDrawer = () => setDrawer(!Draweropen);

  const [siteLoader, setSiteLoader, siteLoaderref] = useState(false);

  const navigate = useNavigate();

  const [loginStatus, setLoginStatus] = useState(false);
  useEffect(() => {
    let token_check = sessionStorage.getItem("user_token");
    if (token_check) {
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
  }, []);

  const loginNave = async () => {
    navigate("/login");
  };

  useEffect(() => {
    return () => {
      socket.disconnect();
    };
  }, [socket]);

  const Movelogin = () => {
    navigate("/login");
  };

  const [activeTab, setActiveTab] = useState("mytrade"); // Default to 'mytrade'

  const [headCurrencies, setHeadCurrencies, headCurrenciesref] = useState("");
  const [HeadData, setHeadData, HeadDataref] = useState("");
  const [SelectedToken, setSelectedToken, SelectedTokenref] = useState("");


  const handleCurrencyClick = (tab) => {
    setHeadCurrencies(tab.currency);
    setHeadData(tab);
    console.log(HeadDataref.current);
    console.log(tab, "currency");
  };

  const [isFormHead, setIsFormHead] = useState("open");
  const [isFormHeadSecond, setIsFormHeadSecond] = useState("open");
  const [isFormLimit, setIsFormLimit] = useState("limit");
  const [isFormLimitSecond, setIsFormLimitSecond] = useState(false);

  const handleFormHeadSecond = (order) => {
    setIsFormHeadSecond(order);
    if (!isFormLimitSecond) {
      setPrice(
        isFormHeadSecond === "open"
          ? Math.floor(selectedPairref.current.aI)
          : Math.floor(selectedPairref.current.bI)
      );
    } else {
      setPrice(selectedPairref.current.mI);
    }
  };

  // const handleLimitSecond = (order) => {
  //   setIsFormLimitSecond(order);
  // };

  const optionsOpen = [
    { text: "GTC", value: "GTC" },
    { text: "IOC", value: "IOC" },
    { text: "FOK", value: "FOK" },
  ];

  // subheader arrow functionality
  const sliderRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  const handleRightClick = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: 50,
        behavior: "smooth",
      });
    }
  };

  const handleLeftClick = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -50,
        behavior: "smooth",
      });
    }
  };

  const aroundATMOptions = [
    { text: "2", value: "2" },
    { text: "3", value: "3" },
    { text: "4", value: "4" },
    { text: "5", value: "5" },
    { text: "6", value: "6" },
    { text: "7", value: "7" },
  ];

  const strikeFromOptions = [
    { text: "520", value: "520" },
    { text: "540", value: "540" },
    { text: "550", value: "550" },
    { text: "570", value: "570" },
    { text: "580", value: "580" },
    { text: "590", value: "590" },
  ];

  const strikeToOptions = [
    { text: "520", value: "520" },
    { text: "540", value: "540" },
    { text: "550", value: "550" },
    { text: "570", value: "570" },
    { text: "580", value: "580" },
    { text: "590", value: "590" },
  ];

  // fav left arrow
  const favSliderRef = useRef(null);
  const [FavLeftArrow, setFavLeftArrow] = useState(false);
  const [FavRightArrow, setFavRightArrow] = useState(true);

  const handleRightFavClick = () => {
    if (favSliderRef.current) {
      favSliderRef.current.scrollBy({
        left: 50,
        behavior: "smooth",
      });
    }
  };

  const handleLeftFavClick = () => {
    if (favSliderRef.current) {
      favSliderRef.current.scrollBy({
        left: -50,
        behavior: "smooth",
      });
    }
  };

  const [isCheckShow, setIsCheckShow] = useState(false);

  const handleCheckClick = () => {
    setIsCheckShow(!isCheckShow);
  };

  const [strikeMin, setStrikeMin] = useState("");
  const [strikeMax, setStrikeMax] = useState("");
  const [isStrikeShow, setIsStrikeShow] = useState(false);


  const handleStrikeClick = () => {
    setIsStrikeShow(!isStrikeShow);
  };

  const [iconTab, setIconTab] = useState("chart");
  const [tradeState, setTradestate, tradeStateref] = useState("chart");

  const handleIconClick = (tab) => {

    console.log(tab, "tabs");
    setIconTab(tab);
    setTradestate(tab);
  };

  const [activeTabhead, setActiveTabHead, activeTabheadref] =
    useState("position");

  const handleTabs = async (value) => {
    setActiveTabHead(value);
  };

  const [optionChain, setOptionChain] = useState({});
  const [selectedPair, setselectedPair, selectedPairref] = useState("");
  const [ChartSymbol, setChartSymbol, ChartSymbolref] = useState("");


  const [selectedExpiry, setSelectedExpiry, selectedExpiryref] = useState(null);
  const [liveSubCoins, setLiveSubCoins] = useState(null); // use original as default

  useEffect(() => {
    getLiveMarket();
    return () => {
      socket.off("OptionalMarket");
    };
  }, [0]);


  const handleChangeSymbol = (symbol) => {
    setChartSymbol(symbol);

  };

  useEffect(() => {
    console.log(headCurrenciesref.current);
    if (headCurrenciesref.current) {
      getLiveOptionTicker(headCurrenciesref.current);
    }

    if (loginStatus == true) {
      const split = headCurrenciesref.current.split("USDT")[0];
      console.log(`${split}_USDT`);
      getUserbalance(`${split}_USDT`);
    }
    return () => {
      socket.off("OptionalTickerPrice");
    };
  }, [headCurrenciesref.current]);

  // const getLiveMarket = async () => {
  //   try {
  //     setSiteLoader(true);
  //     setBookError(null);

  //     socket.emit("GetOptionalMarket");
  //     socket.off("OptionalMarket");

  //     socket.on("OptionalMarket", (response) => {
  //       setSiteLoader(false);

  //       if (response?.data) {
  //         const marketData = response.data;


  //         console.log(marketData, "marketData");

  //         // Update each coin in subHeadCoin based on the live socket data
  //         const updatedCoins = subHeadCoin.map((coin) => {
  //           const key = coin.currency.toLowerCase(); // e.g. "bnbusdt"

  //           const marketEntry = marketData[key];


  //           console.log(marketEntry, "marketEntry");

  //           if (marketEntry) {
  //             const livePrice = parseFloat(marketEntry.lastprice.lastprice);
  //             const oldPrice = parseFloat(coin.price);

  //             return {
  //               ...coin,
  //               price: livePrice.toFixed(4),
  //               tradeSignal: livePrice >= oldPrice,
  //             };
  //           }
  //           return coin;
  //         });

  //         setLiveSubCoins(updatedCoins);

  //         if (!headCurrenciesref.current) {
  //           handleCurrencyClick(updatedCoins[0]);
  //         }
  //       } else {
  //         setBookError("No data received");
  //       }
  //     });

  //     // Add timeout for BookError handling
  //     setTimeout(() => {
  //       if (siteLoaderref.current) {
  //         setSiteLoader(false);
  //         setBookError("Connection timeout");
  //       }
  //     }, 10000); // 10 second timeout
  //   } catch (err) {
  //     setSiteLoader(false);
  //     setBookError(err.message);
  //     console.error("Error fetching option book:", err);
  //   }
  // };


  const getLiveMarket = async () => {
    try {
      setSiteLoader(true);
      setBookError(null);

      // Emit socket request
      socket.emit("GetOptionalMarket");

      // Clear old listener
      socket.off("OptionalMarket");

      // Listen for fresh data
      socket.on("OptionalMarket", (response) => {
        setSiteLoader(false);

        if (response?.data) {
          const marketData = response.data;

          // Map subHeadCoin into a dictionary for quick lookup
          const staticCoinMap = {};
          subHeadCoin.forEach((coin) => {
            staticCoinMap[coin.currency.toLowerCase()] = coin;
          });

          // Loop through only socket coins and match them with static list
          const updatedCoins = Object.entries(marketData)
            .map(([key, data]) => {
              const staticInfo = staticCoinMap[key.toLowerCase()];

              if (!staticInfo) return null; // Skip unknown coins

              const livePrice = parseFloat(data.lastprice?.lastprice || "0");
              const oldPrice = parseFloat(staticInfo.price || "0");

              return {
                ...staticInfo,
                price: livePrice.toFixed(4),
                tradeSignal: livePrice >= oldPrice,
              };
            })
            .filter(Boolean); // Remove null entries

          setLiveSubCoins(updatedCoins);
          setSelectedToken(updatedCoins[0]);

          if (!headCurrenciesref.current && updatedCoins.length > 0) {
            handleCurrencyClick(updatedCoins[0]);
          }
        } else {
          setBookError("No data received");
        }
      });

      // Timeout error fallback
      setTimeout(() => {
        if (siteLoaderref.current) {
          setSiteLoader(false);
          setBookError("No Data Found");
        }
      }, 10000); // 10s timeout
    } catch (err) {
      setSiteLoader(false);
      setBookError(err.message);
      console.error("Error fetching option book:", err);
    }
  };


  const getLiveOptionTicker = async (underlying) => {
    try {
      // console.log("📥 Live Option Chain:", underlying);

      // 👉 Start loader
      setSiteLoader(true);

      // Emit the request
      socket.emit("GetOptionalTickerPrice", { symbol: underlying });

      // Clear any existing listeners to avoid memory leaks or duplicate triggers
      socket.off("OptionalTickerPrice");

      // Set up the new listener
      socket.on("OptionalTickerPrice", (response) => {
        // ✅ Stop loader when response arrives

        if (response?.data) {
          // console.log("📥 Live Option Chain:", response.data.data);
          setOptionChain(response.data.data);

          const expiryKeys = Object.keys(response.data.data).sort(
            (a, b) => Number(a) - Number(b)
          );

          if (
            !selectedExpiryref.current ||
            !expiryKeys.includes(selectedExpiryref.current)
          ) {
            const defaultExpiry = expiryKeys[0];
            setSelectedExpiry(defaultExpiry);
            console.log("🆕 Default expiry selected:", defaultExpiry);
          }
          setSiteLoader(false);
        } else {
          console.warn("No data received in OptionalTickerPrice");
          setSiteLoader(false);
        }
      });

      // Optional: Add a timeout in case socket never responds
      setTimeout(() => {
        setSiteLoader(false);
      }, 10000); // 10 seconds timeout
    } catch (error) {
      console.error("Error in getLiveOptionTicker:", error);
      setSiteLoader(false); // stop loader on error
    }
  };

  const [BookLoading, setBookLoading] = useState(false);
  const [BookError, setBookError] = useState(null);
  const [bookData, setBookData] = useState(null);

  const getLiveOptionBook = async (underlying) => {
    try {
      setBookLoading(true);
      setBookError(null);

      socket.emit("GetOptionalOrderBook", { symbol: underlying });
      socket.off("OptionalOrderBook");

      socket.on("OptionalOrderBook", (response) => {
        setBookLoading(false);

        if (response?.data) {
          // console.log("📥 Live Option Chain:", response.data);
          setBookData(response.data);
          // Process your data here
        } else {
          setBookError("No data received");
        }
      });

      // Add timeout for BookError handling
      setTimeout(() => {
        if (BookLoading) {
          setBookLoading(false);
          setBookError("No Data Found");
        }
      }, 10000); // 10 second timeout
    } catch (err) {
      setBookLoading(false);
      setBookError(err.message);
      console.error("Error fetching option book:", err);
    }
  };

  const [frombalance, setFromBalance, frombalanceref] = useState(0);
  const [tobalance, settobalance, tobalanceref] = useState(0);
  const [changeP, setchangeP, changePref] = useState(0);

  const getUserbalance = async (pair) => {
    var obj = {
      pair: pair,
    };
    var data = {
      apiUrl: apiService.getparUserBalance,
      payload: obj,
    };
    setSiteLoader(true);
    var resp = await postMethod(data);
    setSiteLoader(false);

    if (resp.status) {
      var getFromBalance = resp.data.fromCurrency;
      var getToBalance = resp.data.toCurrency;
      setFromBalance(getFromBalance.totalBalance);
      settobalance(getToBalance.totalBalance);
    } else {
    }
  };

  const processOrderBook = (data) => {
    if (!data) return { bids: [], asks: [] };

    return {
      bids:
        data.bids?.map((bid) => ({
          price: bid.price,
          quantity: bid.quantity,
          type: "bid",
        })) || [],
      asks:
        data.asks?.map((ask) => ({
          price: ask.price,
          quantity: ask.quantity,
          type: "ask",
        })) || [],
    };
  };

  const { bids, asks } = processOrderBook(bookData);

  const rows =
    selectedExpiryref.current && optionChain[selectedExpiryref.current]
      ? optionChain[selectedExpiryref.current]
      : [];

  const formatExpiryDate = (dateStr) => {
    const str = String(dateStr);
    return `20${str.slice(0, 2)}-${str.slice(2, 4)}-${str.slice(4, 6)}`;
  };

  const timeLeft = useExpiryCountdown(selectedExpiryref.current);

  const FEE_RATES = {
    transaction: 0.0003, // 0.03%
    exercise: 0.00015, // 0.015%
    liquidation: 0.0019, // 0.19%
  };
  const [price, setPrice, priceref] = useState();
  const [iv, setIv] = useState("");
  const [amount, setAmount, amountref] = useState();
  const [maxAmount, setMaxAmount] = useState(0);
  const [availableBalance, setAvailableBalance] = useState(0);
  const [cost, setCost] = useState(0);
  const [fees, setFees] = useState({
    transaction: 0,
    exercise: 0,
    liquidation: 0,
    total: 0,
  });

  useEffect(() => {
    if (priceref.current && amountref.current) {
      const baseCost = amountref.current * parseFloat(priceref.current);
      const transactionFee = baseCost * FEE_RATES.transaction;
      const exerciseFee = baseCost * FEE_RATES.exercise;
      const liquidationFee = baseCost * FEE_RATES.liquidation;
      const totalFees = transactionFee + exerciseFee + liquidationFee;
      const totalCost = baseCost + totalFees;

      setCost(totalCost.toFixed(4));
      setFees({
        transaction: transactionFee.toFixed(6),
        exercise: exerciseFee.toFixed(6),
        liquidation: liquidationFee.toFixed(6),
        total: totalFees.toFixed(6),
      });
    }
  }, [priceref.current, amountref.current, isFormLimitSecond]);

  const [buttonLoader, setbuttonLoader] = useState(false);

  const handleSubmit = async (e) => {
    console.log("function call");

    const action = isFormHeadSecond;
    const priceValue = parseFloat(priceref.current);
    const amountValue = parseFloat(amountref.current);

    if (isNaN(amountValue)) {
      toast.warning("Please enter the amount");
      return;
    }

    if (priceValue <= 0) {
      toast.warning("Price must be greater than 0.");
      return;
    }

    if (amountValue < 1) {
      toast.warning("Amount must be at least 1 contract.");
      return;
    }

    if (tobalanceref.current < cost) {
      toast.error("Insufficient balance");
      return;
    }

    const obj = {
      symbol: selectedPairref.current?.symbol ?? "",
      side: action == "open" ? "BUY" : "SELL",
      quantity: amountValue,
      price: priceValue,
      iv,
      tif: "GTC",
    };

    const data = {
      apiUrl: apiService.placeOptionalOrder,
      payload: obj,
    };

    try {
      // toggleDrawer();
      setbuttonLoader(true);

      const resp = await postMethod(data);

      if (resp.status === true) {
        toast.success(resp.Message || "Order placed successfully");
      } else {
        toast.error(resp.Message || "Failed to place order");
      }
    } catch (error) {
      console.error("Submit Error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setbuttonLoader(false);
    }
  };



  const handlePriceChange = (e) => {
    const value = e.target.value;
    setPrice(value);
    updateCost(amountref.current, value);
  };

  const updateCost = (amt, price) => {
    const calculatedCost = amt * (price || 0);
    setCost(calculatedCost.toFixed(2));
  };

  const handleIvChange = (e) => {
    setIv(e.target.value);
  };

  const handleAmountChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    setAmount(value);
    updateCost(value, priceref.current);
  };

  const filteredRows = rows.filter((row) => {
    const min = parseFloat(strikeMin);
    const max = parseFloat(strikeMax);

    if (isStrikeShow && !isNaN(min) && !isNaN(max)) {
      return row.strike >= min && row.strike <= max;
    }
    return true;
  });


  return (
    <>
      <Header />

      <Drawer
        anchor="right"
        open={Draweropen}
        onClose={toggleDrawer}
        PaperProps={{
          style: {
            min_width: 350,
            padding: 10,
            maxWidth: 500,
            background: "#1e2026",
          },
        }}
      >
        <div className="p-sm-0 no_pad_rghnew nopad_bt_opylo">
          {tradeStateref.current === "chart" && (
            <>
              <div className="op-subHeader-flex-newone backgrnd_1026">
                <div className="op-sbh-one-flex">
                  <div>
                    <div className="op-sbh-title">
                      {selectedPairref.current?.symbol ?? ""}
                    </div>
                    <span className="op-sbh-span">1,014,961.40x</span>
                  </div>
                </div>

                <div className="op-sph-two">
                  {showLeftArrow && (
                    <div
                      className="op-sbh-arr-left-righttop"
                      onClick={handleLeftClick}
                    >
                      <i className="fa-solid fa-chevron-left"></i>
                    </div>
                  )}

                  <div className="op-sph-two-flex-newone" ref={sliderRef}>
                    <div>
                      <span className="op-sph-two-title">24h High/Low/Vol</span>
                      <div className="op-sph-two-content">
                        <span>{selectedPairref.current?.h ?? ""}</span> /{" "}
                        <span>{selectedPairref.current?.l ?? ""}</span> /{" "}
                        <span>{selectedPairref.current?.V ?? ""}</span>
                      </div>
                    </div>

                    <div>
                      <span className="op-sph-two-title">Time to Expiry</span>
                      <div className="op-sph-two-content">{timeLeft}</div>
                    </div>
                    <div>
                      <span className="op-sph-two-title">
                        IV (Bid/Mark/Ask)
                      </span>
                      <div className="op-sph-two-content">
                        <span>{selectedPairref.current?.bI ?? ""}</span> /{" "}
                        <span>{selectedPairref.current?.mI ?? ""}</span> /{" "}
                        <span>{selectedPairref.current?.aI ?? ""}</span>
                      </div>
                    </div>
                    <div>
                      <span className="op-sph-two-title">Delta</span>
                      <div className="op-sph-two-content">
                        {selectedPairref.current?.d ?? ""}
                      </div>
                    </div>
                    <div>
                      <span className="op-sph-two-title">Gamma</span>
                      <div className="op-sph-two-content">
                        {selectedPairref.current?.g ?? ""}
                      </div>
                    </div>
                    <div>
                      <span className="op-sph-two-title">Theta</span>
                      <div className="op-sph-two-content">
                        {selectedPairref.current?.te ?? ""}
                      </div>
                    </div>
                    <div>
                      <span className="op-sph-two-title">Vega</span>
                      <div className="op-sph-two-content">
                        {selectedPairref.current?.v ?? ""}
                      </div>
                    </div>
                  </div>

                  {showRightArrow && (
                    <div
                      className="op-sbh-arr-right-righttop"
                      onClick={handleRightClick}
                    >
                      <i className="fa-solid fa-chevron-right"></i>
                    </div>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-5 Orderbooks p-0">
                  <div className="order-book-container">
                    <h3>Order Book</h3>

                    {BookLoading && (
                      <div className="book-loader">
                        <div className="">
                          <Bars
                            height="40  "
                            width="40 "
                            color="#ffc630"
                            ariaLabel="bars-loading"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                          />
                        </div>
                      </div>
                    )}

                    {BookError && (
                      <div className="book-error">
                        {BookError}
                      </div>
                    )}

                    {!BookLoading && !BookError && (
                      <table className="order-book-table">
                        <thead>
                          <tr>
                            <th>Price (USDT)</th>
                            <th>Size</th>
                            <th>Sum</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[...asks]
                            .sort((a, b) => b.price - a.price)
                            .map((ask, i) => (
                              <tr key={`ask-${i}`} className="ask-row">
                                <td className="ask-price">
                                  {ask.price.toFixed(2)}
                                </td>
                                <td>{ask.quantity.toFixed(2)}</td>
                                <td>
                                  {asks
                                    .slice(0, i + 1)
                                    .reduce((sum, a) => sum + a.quantity, 0)
                                    .toFixed(2)}
                                </td>
                              </tr>
                            ))}
                          <div className="changeprice d-flex">
                            <p
                              className={
                                changePref.current.toFixed(2) > 0
                                  ? "active-text-green"
                                  : "active-text-red"
                              }
                            >
                              {selectedPairref.current?.c || 0}
                            </p>
                            <span>{changePref.current.toFixed(2)}%</span>
                          </div>


                          {[...bids]
                            .sort((a, b) => b.price - a.price)
                            .map((bid, i) => (
                              <tr key={`bid-${i}`} className="bid-row">
                                <td className="bid-price">
                                  {bid.price.toFixed(2)}
                                </td>
                                <td>{bid.quantity.toFixed(2)}</td>
                                <td>
                                  {bids
                                    .slice(0, i + 1)
                                    .reduce((sum, b) => sum + b.quantity, 0)
                                    .toFixed(2)}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
                <div className="col-7 p-0">
                  <div className="op-order_form resp_pad_potord">
                    <div className="op-order-taps">
                      <span
                        className={`op-or-btn ${isFormHeadSecond === "open" ? "active" : ""
                          }`}
                        onClick={() => handleFormHeadSecond("open")}
                      >
                        Open
                      </span>
                      <span
                        className={`op-or-btn ${isFormHeadSecond === "close" ? "active" : ""
                          }`}
                        onClick={() => handleFormHeadSecond("close")}
                      >
                        Close
                      </span>
                    </div>

                    <div className="op-av-wrap">
                      <div>
                        <span className="op-av-span">Avbl - </span>
                        <span className="op-av-span num mx-1">
                          {tobalanceref.current ?? "-----"} USDT
                        </span>
                      </div>
                    </div>

                    <form >
                      <div className="row mt-3 align-items-center">
                        <div className="col-lg-9 padopt_orfrin_0">
                          <div className="op-frm-input-wrap">
                            <input
                              type="number"
                              className="op-frm-input"
                              placeholder="Price"
                              value={price}
                              disabled={isFormLimitSecond}
                              onChange={handlePriceChange}
                              step="0.01"
                            />
                            <span className="op-frm-span">USDT</span>
                          </div>
                        </div>
                        <div className="col-lg-3">
                          <div className="op-or-limit-wrap mt-0">
                            <span
                              className={`op-or-limit-btn ${isFormLimitSecond ? "active" : ""
                                }`}
                              onClick={() => {
                                setIsFormLimitSecond(!isFormLimitSecond);
                                if (
                                  !isFormLimitSecond &&
                                  selectedPairref.current
                                ) {
                                  setPrice(
                                    isFormHeadSecond === "open"
                                      ? Math.floor(selectedPairref.current.aI)
                                      : Math.floor(selectedPairref.current.bI)
                                  );
                                } else {
                                  setPrice(selectedPairref.current.mI);
                                }
                              }}
                            >
                              BBO
                            </span>
                          </div>
                        </div>

                        {/* <div className="col-lg-12 mt-3">
                          <div className="op-frm-input-wrap">
                            <input
                              type="number"
                              className="op-frm-input"
                              placeholder="IV"
                              value={iv}
                              onChange={handleIvChange}
                              step="0.1"
                            />
                          </div>
                        </div> */}

                        <div className="col-lg-12 mt-3">
                          <div className="op-frm-input-wrap">
                            <input
                              type="number"
                              className="op-frm-input"
                              placeholder="Amount"
                              value={amountref.current}
                              onChange={handleAmountChange}
                              min="0"
                              step="1"
                            />
                            <span className="op-frm-span span-12">
                              contract
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="op-av-wrap op-mx-wrap">
                        <div>
                          <span className="op-av-span">Max Amount: </span>
                          <span className="op-av-span num mx-1">
                            {maxAmount} USDT
                          </span>
                        </div>
                      </div>

                      <div className="op-av-wrap">
                        <div>
                          <span className="op-av-span">TIF </span>
                          <span>
                            <Dropdown
                              inline
                              placeholder="GTC"
                              options={optionsOpen}
                              className="mx-3 op-av-dropdown"
                            />
                          </span>
                        </div>

                        <div>
                          <span className="op-av-span num">Cost: </span>
                          <span className="op-av-span mx-1">{cost} USDT</span>
                        </div>
                      </div>

                      {loginStatus == true ? (
                        <button
                          type="submit"
                          className={`op-order_form-btn ${isFormHeadSecond != "open" ? "red" : ""
                            }`}
                          onClick={handleSubmit}
                        // disabled={!priceref.current || !amountref.current}
                        >
                          {isFormHeadSecond === "open" ? "Buy" : "Sell"}
                        </button>
                      ) : (
                        <Button
                          className="op-order_form-btn yellow mt-3"
                          onClick={() => loginNave()}
                        >
                          Login to continue
                        </Button>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Drawer>

      {siteLoaderref.current == true ? (
        <div className="book-loader">
          <div className="loadercss">
            <Bars
              height="80"
              width="80"
              color="#ffc630"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        </div>
      ) : (


        <div className="new-popup-height container-fluid">
          <div className="header">
            <main className="min-height-100vh ">
              <div className="row opt_new_mainn">
                <div className="col-lg-12 opt_new_mainn_lef p-0">
                  <div className="op-subHeader-one">
                    <ul className="nav nav-pills op-subHeader-icon">
                      <li
                        onClick={() => handleIconClick("chart")}
                        className={`icon-list ${iconTab === "chart" ? "active" : ""
                          }`}
                      >
                        <span className={`op-grid-icon`}>
                          <i className="bi bi-grid-1x2-fill"></i>
                        </span>
                      </li>
                      <li
                        onClick={() => {
                          handleIconClick("candles");
                          handleChangeSymbol(filteredRows[0].call.symbol);
                        }

                        }
                        className={`icon-list ${iconTab === "candles" ? "active" : ""
                          }`}
                      >
                        <span className="op-grid-icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlSpace="preserve"
                            enableBackground="new 0 0 100 100"
                            version="1.0"
                            viewBox="0 0 100 100"
                            width="22px"
                            height="22px"
                            fill={iconTab === "candles" ? "#ffd700" : "#8b8b8c"}
                          >
                            <g id="candlestick-chart-fluctuating">
                              <path d="M33.333,44.961v21.706c0,4.114-3.347,7.463-7.461,7.463H25v5.037c0,2.303-1.866,4.167-4.167,4.167 s-4.167-1.864-4.167-4.167v-5.037h-0.873c-4.114,0-7.461-3.349-7.461-7.463V44.961c0-4.114,3.347-7.461,7.461-7.461h0.873v-4.167 c0-2.301,1.866-4.167,4.167-4.167S25,31.032,25,33.333V37.5h0.873C29.987,37.5,33.333,40.847,33.333,44.961z M84.204,37.5h-0.871 v-4.167c0-2.301-1.864-4.167-4.167-4.167c-2.303,0-4.167,1.866-4.167,4.167V37.5h-0.871c-4.114,0-7.463,3.347-7.463,7.461v21.706 c0,4.114,3.349,7.463,7.463,7.463H75v5.037c0,2.303,1.864,4.167,4.167,4.167c2.303,0,4.167-1.864,4.167-4.167v-5.037h0.871 c4.114,0,7.463-3.349,7.463-7.463V44.961C91.667,40.847,88.318,37.5,84.204,37.5z M55.037,25h-0.871v-4.167 c0-2.301-1.866-4.167-4.167-4.167s-4.167,1.866-4.167,4.167V25h-0.873c-4.114,0-7.461,3.347-7.461,7.461v22.577 c0,4.114,3.347,7.463,7.461,7.463h0.873v4.167c0,2.303,1.866,4.167,4.167,4.167s4.167-1.864,4.167-4.167V62.5h0.871 c4.114,0,7.463-3.349,7.463-7.463V32.461C62.5,28.347,59.151,25,55.037,25z" />
                            </g>
                          </svg>
                        </span>
                      </li>
                    </ul>
                    <div className="op-subHeader-one-inner">
                      <ul className="nav nav-pills op-subHeader-ml">
                        {liveSubCoins?.map((data) => {
                          return (
                            <div
                              className={`op-subHeader-icons-wrapper ${headCurrenciesref.current == data.currency
                                ? "active"
                                : ""
                                } `}
                              key={data.id}
                              onClick={() => handleCurrencyClick(data)}
                            >
                              <img
                                className="op-subHeader-inner-icon"
                                src={data.img}
                                alt=""
                              />

                              <div className="contract-and-info">
                                <div
                                  data-bn-type="text"
                                  className="contract-tab-item css-1jpjezl "
                                >
                                  {data.currency}
                                </div>
                                <div className="info-container mt-1">
                                  <div
                                    className={`css-1p5bven 
                                        ${data.tradeSignal
                                        ? "tradeGreen"
                                        : "tradeRed"
                                      }`}
                                  >
                                    {data.price}
                                  </div>
                                  <div
                                    className={`icon-container ${data.tradeSignal ? "tradeGreen" : "tradeRed"
                                      }`}
                                  >
                                    <i
                                      className={`${data.tradeSignal
                                        ? data.greenIcon
                                        : data.redIcon
                                        }`}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </ul>
                    </div>
                  </div>

                  {tradeStateref.current == "chart" ? (
                    <>
                      <div className="op-fav new_fav_opt">
                        {/* fav  */}
                        <div className="op-sph-two op-fav-inner">
                          {FavLeftArrow && (
                            <div
                              className="op-fav-arr-left"
                              onClick={handleLeftFavClick}
                            >
                              <i className="fa-solid fa-chevron-left"></i>
                            </div>
                          )}

                          <div className="op-fav-left" ref={favSliderRef}>
                            {Object.keys(optionChain)
                              .sort()
                              .map((expiry) => (
                                <div
                                  className={`op-fav-tag ${selectedExpiryref.current === expiry
                                    ? "active"
                                    : ""
                                    }`}
                                  key={expiry}
                                  onClick={() => setSelectedExpiry(expiry)}
                                >
                                  {formatExpiryDate(expiry)}
                                </div>
                              ))}
                          </div>


                        </div>

                        {/* strike */}
                        <div className="op-fav-right">

                          <div className="d-flex align-items-center">
                            <div className="op-fav-check-wrap">
                              <input
                                type="checkbox"
                                id="strikerange"
                                className="op__check"
                                checked={isStrikeShow}
                                onChange={() => setIsStrikeShow(!isStrikeShow)}
                              />
                              <label htmlFor="strikerange"></label>
                            </div>

                            <label htmlFor="strikerange" className="op-st-label">
                              Strike Range
                            </label>

                            {isStrikeShow && (
                              <div className="d-flex align-items-center ms-3">
                                <input
                                  type="number"
                                  placeholder="Min"
                                  value={strikeMin}
                                  onChange={(e) => setStrikeMin(e.target.value)}
                                  className="form-control me-2 strike"
                                  style={{ width: "100px" }}
                                />
                                <span className="op-st-span"> - </span>
                                <input
                                  type="number"
                                  placeholder="Max"
                                  value={strikeMax}
                                  onChange={(e) => setStrikeMax(e.target.value)}
                                  className="form-control ms-2 strike"
                                  style={{ width: "100px" }}
                                />
                              </div>
                            )}
                          </div>

                        </div>
                      </div>

                      <div className="opt_ove_flo">
                        <div className="opt_fav_beloman">
                          <span className="opt_fav_beloman_thispa">Calls</span>
                          <div className="opt_fav_belo_cenman">
                            <span className="opt_fav_beloman_tnipa">
                              {SelectedTokenref.current.currency} price : {SelectedTokenref.current.price}
                            </span>
                            <span className="opt_fav_beloman_thispa">
                              {" "}
                              {formatExpiryDate(selectedExpiryref.current)}{" "}
                            </span>
                            <span className="opt_fav_beloman_tnipa">
                              Time to Expiry: {timeLeft} (Daily)
                            </span>
                          </div>
                          <span className="opt_fav_beloman_thispa">Puts</span>
                        </div>

                        <div className="opt_tab_new_now">
                          <div className="opt_tabs_newbod">
                            {/* Table Headings */}
                            <div className="opt_tabs_newhad px-4">
                              {["Chart",
                                "Open",
                                "Delta",
                                "Bid Size",
                                "Bid/IV",
                                "Mark/IV",
                                "Ask/IV",
                                "Ask Size",
                                "Position",
                              ].map((label, idx) => (
                                <span
                                  key={idx}
                                  className="opt_tabs_newbod_inner_spn"
                                >
                                  {label}
                                </span>
                              ))}
                            </div>

                            {filteredRows.map((row, index) => (
                              <div
                                key={index}

                                className={`opt_tabs_newbod_inner  ${Number(HeadDataref.current.price) >
                                  Number(row.call?.strike)
                                  ? "bck_optr_dim thic_bor_pot"
                                  : ""
                                  }`}
                              >
                                <span className="op-grid-icon" onClick={() => {
                                  handleChangeSymbol(row.call.symbol);
                                  handleIconClick("candles");
                                }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlSpace="preserve"
                                    enableBackground="new 0 0 100 100"
                                    version="1.0"
                                    viewBox="0 0 100 100"
                                    width="22px"
                                    height="22px"
                                    fill={iconTab === "candles" ? "#ffd700" : "#8b8b8c"}
                                  >
                                    <g id="candlestick-chart-fluctuating">
                                      <path d="M33.333,44.961v21.706c0,4.114-3.347,7.463-7.461,7.463H25v5.037c0,2.303-1.866,4.167-4.167,4.167 s-4.167-1.864-4.167-4.167v-5.037h-0.873c-4.114,0-7.461-3.349-7.461-7.463V44.961c0-4.114,3.347-7.461,7.461-7.461h0.873v-4.167 c0-2.301,1.866-4.167,4.167-4.167S25,31.032,25,33.333V37.5h0.873C29.987,37.5,33.333,40.847,33.333,44.961z M84.204,37.5h-0.871 v-4.167c0-2.301-1.864-4.167-4.167-4.167c-2.303,0-4.167,1.866-4.167,4.167V37.5h-0.871c-4.114,0-7.463,3.347-7.463,7.461v21.706 c0,4.114,3.349,7.463,7.463,7.463H75v5.037c0,2.303,1.864,4.167,4.167,4.167c2.303,0,4.167-1.864,4.167-4.167v-5.037h0.871 c4.114,0,7.463-3.349,7.463-7.463V44.961C91.667,40.847,88.318,37.5,84.204,37.5z M55.037,25h-0.871v-4.167 c0-2.301-1.866-4.167-4.167-4.167s-4.167,1.866-4.167,4.167V25h-0.873c-4.114,0-7.461,3.347-7.461,7.461v22.577 c0,4.114,3.347,7.463,7.461,7.463h0.873v4.167c0,2.303,1.866,4.167,4.167,4.167s4.167-1.864,4.167-4.167V62.5h0.871 c4.114,0,7.463-3.349,7.463-7.463V32.461C62.5,28.347,59.151,25,55.037,25z" />
                                    </g>
                                  </svg>

                                </span>


                                <div className="cols" onClick={async () => {
                                  socket.off("OptionalOrderBook");
                                  await getLiveOptionBook(row.call.symbol);
                                  console.log(row.call, "updatedCoins");
                                  setselectedPair(row.call);
                                  if (!isFormLimitSecond) {
                                    setPrice(
                                      isFormHeadSecond === "open"
                                        ? Math.floor(selectedPairref.current.aI)
                                        : Math.floor(selectedPairref.current.bI)
                                    );
                                  } else {
                                    setPrice(selectedPairref.current.mI);
                                  }
                                  toggleDrawer();
                                  setchangeP(
                                    ((selectedPairref.current?.c -
                                      selectedPairref.current?.l) /
                                      selectedPairref.current?.l) *
                                    100
                                  );
                                }}>
                                  <span className="opt_tabs_newbod_inner_spn">
                                    {row.call?.o !== undefined
                                      ? Number(row.call?.o).toFixed(2)
                                      : "--"}
                                  </span>
                                  <span className="opt_tabs_newbod_inner_spn">
                                    {row.call?.d !== undefined
                                      ? Number(row.call?.d).toFixed(5)
                                      : "--"}
                                  </span>
                                  <span className="opt_tabs_newbod_inner_spn">
                                    {row.call?.b !== undefined
                                      ? Number(row.call?.b).toFixed(2)
                                      : "--"}
                                  </span>

                                  <div className="qwerty">
                                    <span className="asdfgh">
                                      {row.call?.bI !== undefined
                                        ? Number(row.call?.bI).toFixed(4)
                                        : "--"}
                                    </span>
                                  </div>

                                  <div className="qwerty">
                                    <span className="cvbn">
                                      {row.call?.mI !== undefined
                                        ? Number(row.call?.mI).toFixed(4)
                                        : "--"}
                                    </span>
                                  </div>

                                  <div className="qwerty">
                                    <span className="mnbhg">
                                      {row.call?.aI !== undefined
                                        ? Number(row.call?.aI).toFixed(4)
                                        : "--"}
                                    </span>
                                  </div>

                                  <span className="opt_tabs_newbod_inner_spn pdg_let2">
                                    {row.call?.a !== undefined
                                      ? Number(row.call?.a).toFixed(2)
                                      : "--"}
                                  </span>
                                  <span className="opt_tabs_newbod_inner_spn pdg_let33">
                                    --
                                  </span>


                                </div>



                              </div>
                            ))}
                          </div>

                          <div className="opt-cent-newal">
                            <div className="opt_tabs_newhad justify-content-center">
                              <span>Strike</span>
                            </div>
                            {filteredRows.map((row, index) => (
                              <div className="opt-cent-newal-innn" key={index}>
                                <span>{row.strike}</span>
                              </div>
                            ))}
                          </div>

                          <div className="opt_tabs_newbod">
                            <div className="opt_tabs_newhad">
                              {[
                                "Position",
                                "Ask Size",
                                "Ask/IV",
                                "Mark/IV",
                                "Bid/IV",
                                "Bid Size",
                                "Delta",
                                "Open",
                                "Chart",
                              ].map((label, idx) => (
                                <span
                                  key={idx}
                                  className="opt_tabs_newbod_inner_spn"
                                >
                                  {label}
                                </span>
                              ))}
                            </div>

                            {filteredRows.map((row, index) => (
                              <div
                                key={index}

                                className={`opt_tabs_newbod_inner  ${Number(HeadDataref.current.price) >
                                  Number(row.call?.strike)
                                  ? " "
                                  : "thic_bor_pot bck_optr_dim_red"
                                  }`}
                              >

                                <div className="cols1" onClick={async () => {
                                  socket.off("OptionalOrderBook");
                                  await getLiveOptionBook(row.put.symbol);
                                  setselectedPair(row.put);
                                  if (!isFormLimitSecond) {
                                    setPrice(
                                      isFormHeadSecond === "open"
                                        ? Math.floor(selectedPairref.current.aI)
                                        : Math.floor(selectedPairref.current.bI)
                                    );
                                  } else {
                                    setPrice(selectedPairref.current.mI);
                                  }
                                  toggleDrawer();
                                }}>
                                  <span className="opt_tabs_newbod_inner_spn pdg_let33">
                                    --
                                  </span>
                                  <span className="opt_tabs_newbod_inner_spn pdg_let2">
                                    {row.put?.a !== undefined
                                      ? Number(row.put.a).toFixed(2)
                                      : "--"}
                                  </span>

                                  <div className="qwerty">
                                    <span className="mnbhg">
                                      {" "}
                                      {row.put?.aI !== undefined
                                        ? Number(row.put.aI).toFixed(4)
                                        : "--"}
                                    </span>
                                    {/* <span className="hgfdsa">{row.put?.askIV || "--"}%</span> */}
                                  </div>

                                  <div className="qwerty">
                                    <span className="cvbn">
                                      {" "}
                                      {row.put?.mI !== undefined
                                        ? Number(row.put.mI).toFixed(4)
                                        : "--"}
                                    </span>
                                    {/* <span className="hgfdsa">{row.put?.markIV || "--"}%</span> */}
                                  </div>

                                  <div className="qwerty">
                                    <span className="asdfgh">
                                      {" "}
                                      {row.put?.bI !== undefined
                                        ? Number(row.put.bI).toFixed(4)
                                        : "--"}
                                    </span>
                                    {/* <span className="hgfdsa">{row.put?.bidIV || "--"}%</span> */}
                                  </div>

                                  <span className="opt_tabs_newbod_inner_spn">
                                    {" "}
                                    {row.put?.b !== undefined
                                      ? Number(row.put.b).toFixed(2)
                                      : "--"}
                                  </span>
                                  <span className="opt_tabs_newbod_inner_spn">
                                    {" "}
                                    {row.put?.d !== undefined
                                      ? Number(row.put.d).toFixed(5)
                                      : "--"}
                                  </span>
                                  <span className="opt_tabs_newbod_inner_spn">
                                    {row.put?.o !== undefined
                                      ? Number(row.put.o).toFixed(2)
                                      : "--"}
                                  </span>
                                </div>

                                <span className="op-grid-icon" onClick={() => {
                                  handleChangeSymbol(row.put.symbol);
                                  handleIconClick("candles");
                                }}>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlSpace="preserve"
                                    enableBackground="new 0 0 100 100"
                                    version="1.0"
                                    viewBox="0 0 100 100"
                                    width="22px"
                                    height="22px"
                                    fill={iconTab === "candles" ? "#ffd700" : "#8b8b8c"}
                                  >
                                    <g id="candlestick-chart-fluctuating">
                                      <path d="M33.333,44.961v21.706c0,4.114-3.347,7.463-7.461,7.463H25v5.037c0,2.303-1.866,4.167-4.167,4.167 s-4.167-1.864-4.167-4.167v-5.037h-0.873c-4.114,0-7.461-3.349-7.461-7.463V44.961c0-4.114,3.347-7.461,7.461-7.461h0.873v-4.167 c0-2.301,1.866-4.167,4.167-4.167S25,31.032,25,33.333V37.5h0.873C29.987,37.5,33.333,40.847,33.333,44.961z M84.204,37.5h-0.871 v-4.167c0-2.301-1.864-4.167-4.167-4.167c-2.303,0-4.167,1.866-4.167,4.167V37.5h-0.871c-4.114,0-7.463,3.347-7.463,7.461v21.706 c0,4.114,3.349,7.463,7.463,7.463H75v5.037c0,2.303,1.864,4.167,4.167,4.167c2.303,0,4.167-1.864,4.167-4.167v-5.037h0.871 c4.114,0,7.463-3.349,7.463-7.463V44.961C91.667,40.847,88.318,37.5,84.204,37.5z M55.037,25h-0.871v-4.167 c0-2.301-1.866-4.167-4.167-4.167s-4.167,1.866-4.167,4.167V25h-0.873c-4.114,0-7.461,3.347-7.461,7.461v22.577 c0,4.114,3.347,7.463,7.461,7.463h0.873v4.167c0,2.303,1.866,4.167,4.167,4.167s4.167-1.864,4.167-4.167V62.5h0.871 c4.114,0,7.463-3.349,7.463-7.463V32.461C62.5,28.347,59.151,25,55.037,25z" />
                                    </g>
                                  </svg>
                                </span>
                              </div>
                            ))}
                          </div>
                        </div>

                        <div className="opt_tab_new_now">

                          {filteredRows.length < 1 && (

                            <img
                              src={require("../assets/no-copytrade-data.webp")}
                              width="100px"
                              className="d-block mx-auto my-5"
                            />
                          )}
                        </div>
                      </div>

                      <div className="m-3">
                        <span className="opt_rectra_spa">
                          Recent Trades (BTC Options)
                        </span>
                      </div>
                      <div className="row opt_ove_flo">
                        <div className="col-lg-6 col-sm-6">
                          <div className="opt_blw_calsputs mt-2">
                            <span className="opt_blw_calsputs_calls">Calls</span>
                            <div className="opt_blw_calsputs_centi">
                              <span> 24h Call Volume: 1775.24</span>
                            </div>
                          </div>
                          <div className="opt_bottom_tabl">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <th className="pad_opy_tbpa">Side</th>
                                  <th>Symbol</th>
                                  <th>Price</th>
                                  <th>Size (Cont)</th>
                                  <th className="text-end">Time</th>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <span>Buy</span>
                                    </td>
                                    <td>BTC-250131-104000-C</td>
                                    <td>820.0</td>
                                    <td className="text-center">0.02</td>
                                    <td className="text-end">
                                      2025-01-27 16:44:31
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span>Buy</span>
                                    </td>
                                    <td>BTC-250131-104000-C</td>
                                    <td>820.0</td>
                                    <td className="text-center">0.02</td>
                                    <td className="text-end">
                                      2025-01-27 16:44:31
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span>Buy</span>
                                    </td>
                                    <td>BTC-250131-104000-C</td>
                                    <td>820.0</td>
                                    <td className="text-center">0.02</td>
                                    <td className="text-end">
                                      2025-01-27 16:44:31
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                          <div className="opt_blw_calsputs_strt mt-2">
                            <div className="opt_blw_calsputs_centi">
                              <span> 24h Put Volume: 1775.24</span>
                            </div>
                            <span className="opt_blw_calsputs_calls">Puts</span>
                          </div>
                          <div className="opt_bottom_tabl">
                            <div className="table-responsive">
                              <table className="table">
                                <thead>
                                  <th className="srt_pad_optta">Side</th>
                                  <th>Symbol</th>
                                  <th>Price</th>
                                  <th>Size (Cont)</th>
                                  <th className="txt_lst_optta">Time</th>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td className="srt_pad_optta">Sell</td>
                                    <td>BTC-250131-104000-C</td>
                                    <td>820.0</td>
                                    <td className="text-center">0.02</td>
                                    <td className="txt_lst_optta">
                                      2025-01-27 16:44:31
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="srt_pad_optta">Sell</td>
                                    <td>BTC-250131-104000-C</td>
                                    <td>820.0</td>
                                    <td className="text-center">0.02</td>
                                    <td className="txt_lst_optta">
                                      2025-01-27 16:44:31
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="srt_pad_optta">Sell</td>
                                    <td>BTC-250131-104000-C</td>
                                    <td>820.0</td>
                                    <td className="text-center">0.02</td>
                                    <td className="txt_lst_optta">
                                      2025-01-27 16:44:31
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div style={{ backgroundColor: "rgb(23 23 26)", padding: "20px", margin_top: "100px" }}>
                        <BinanceOptionsChart symbol={ChartSymbolref.current} />
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="easy_Low_main">
                <div className="easy_Low_main_top">
                  <span
                    className={`easy_low_tabhead ${activeTabheadref.current == "position" ? "active" : ""
                      } `}
                    onClick={() => handleTabs("position")}
                  >
                    Position (0)
                  </span>
                  {tradeStateref.current === "chart" ? (
                    <>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "orders" ? "active" : ""
                          } `}
                        onClick={() => handleTabs("orders")}
                      >
                        Orders (0)
                      </span>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "history" ? "active" : ""
                          } `}
                        onClick={() => handleTabs("history")}
                      >
                        History
                      </span>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "pricealert" ? "active" : ""
                          } `}
                        onClick={() => handleTabs("pricealert")}
                      >
                        Price alerts
                      </span>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "transaction"
                          ? "active"
                          : ""
                          } `}
                        onClick={() => handleTabs("transaction")}
                      >
                        Transactions
                      </span>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "journal" ? "active" : ""
                          } `}
                        onClick={() => handleTabs("journal")}
                      >
                        Journal
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "openorder" ? "active" : ""
                          } `}
                        onClick={() => handleTabs("openorder")}
                      >
                        Open Orders (0)
                      </span>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "orderhistory"
                          ? "active"
                          : ""
                          } `}
                        onClick={() => handleTabs("orderhistory")}
                      >
                        Order History
                      </span>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "tradehistory"
                          ? "active"
                          : ""
                          } `}
                        onClick={() => handleTabs("tradehistory")}
                      >
                        Trade History
                      </span>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "exercisehistory"
                          ? "active"
                          : ""
                          } `}
                        onClick={() => handleTabs("exercisehistory")}
                      >
                        Exercise History
                      </span>
                      <span
                        className={`easy_low_tabhead ${activeTabheadref.current == "transactionhistory"
                          ? "active"
                          : ""
                          } `}
                        onClick={() => handleTabs("transactionhistory")}
                      >
                        Transaction History
                      </span>
                    </>
                  )}
                </div>
                <div className="w-100 mb-5">
                  <div className="table-responsive table-cont otc_spot_tableup">
                    <table className="table">
                      <thead>
                        <tr className="stake-head font-satoshi">
                          <th>Symbol</th>
                          <th className="pad-left-23 txt-center">Size</th>
                          <th className="pad-left-23 txt-center">Available</th>
                          <th className="pad-left-23 txt-center">
                            Average Price
                          </th>
                          <th className="pad-left-23 txt-center opt-nowrap">
                            Unrealized PnL
                          </th>
                          <th className="pad-left-23 txt-center opt-nowrap">
                            ROE%
                          </th>
                          <th className="pad-left-23 txt-center opt-nowrap">
                            Market Value
                          </th>
                          <th className="opt-nowrap table-action pad-left-23 pad-rght-tab">
                            Close Position
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr>
                          <td colSpan={8} className="text-center py-5">
                            <div className="empty_data">
                              <div className="empty_data_img py-4">
                                <img
                                  src={require("../assets/no-copytrade-data.webp")}
                                  width="100px"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      )}

    </>
  );
}

export default OptionalTrade;
